import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "sgt_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

// ---- Public ----
export const api = {
  // Results
  latestResult: () => axios.get(`${BASE}/results/latest`).then((r) => r.data),
  results: (params = {}) =>
    axios.get(`${BASE}/results`, { params }).then((r) => r.data),
  resultYears: () => axios.get(`${BASE}/results/years`).then((r) => r.data),
  resultByDate: (iso) =>
    axios.get(`${BASE}/results/by-date/${iso}`).then((r) => r.data),

  // Common number
  commonNumber: () => axios.get(`${BASE}/common-number`).then((r) => r.data),

  // Dreams
  dreams: () => axios.get(`${BASE}/dreams`).then((r) => r.data),

  // Blog
  blog: () => axios.get(`${BASE}/blog`).then((r) => r.data),

  // Auto
  analysis: () => axios.get(`${BASE}/analysis`).then((r) => r.data),
  predict: () => axios.get(`${BASE}/predict`).then((r) => r.data),

  // ---- Auth ----
  login: (username, password) =>
    axios.post(`${BASE}/admin/login`, { username, password }).then((r) => r.data),

  // ---- Admin: Results ----
  createResult: (body) => axios.post(`${BASE}/results`, body, authHeader()).then((r) => r.data),
  updateResult: (id, body) => axios.put(`${BASE}/results/${id}`, body, authHeader()).then((r) => r.data),
  deleteResult: (id) => axios.delete(`${BASE}/results/${id}`, authHeader()).then((r) => r.data),

  // ---- Admin: Common Number ----
  allCommonNumbers: () => axios.get(`${BASE}/common-number/all`, authHeader()).then((r) => r.data),
  upsertCommonNumber: (body) => axios.post(`${BASE}/common-number`, body, authHeader()).then((r) => r.data),
  deleteCommonNumber: (id) => axios.delete(`${BASE}/common-number/${id}`, authHeader()).then((r) => r.data),

  // ---- Admin: Dreams ----
  createDream: (body) => axios.post(`${BASE}/dreams`, body, authHeader()).then((r) => r.data),
  updateDream: (id, body) => axios.put(`${BASE}/dreams/${id}`, body, authHeader()).then((r) => r.data),
  deleteDream: (id) => axios.delete(`${BASE}/dreams/${id}`, authHeader()).then((r) => r.data),

  // ---- Admin: Blog ----
  createBlog: (body) => axios.post(`${BASE}/blog`, body, authHeader()).then((r) => r.data),
  updateBlog: (id, body) => axios.put(`${BASE}/blog/${id}`, body, authHeader()).then((r) => r.data),
  deleteBlog: (id) => axios.delete(`${BASE}/blog/${id}`, authHeader()).then((r) => r.data),
};

// Helpers
export const dmyToSlash = (dmy) => (dmy ? dmy.replaceAll("-", "/") : "");
